import axios from "axios";

// Falls back to same-origin ("/api") when REACT_APP_BACKEND_URL is unset,
// so a missing .env never produces requests to "undefined/api".
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kk_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
